import { render } from "./forgetActiveCode.vue?vue&type=template&id=53d8cad2"
import script from "./forgetActiveCode.vue?vue&type=script&lang=js"
export * from "./forgetActiveCode.vue?vue&type=script&lang=js"

import "./forgetActiveCode.vue?vue&type=style&index=0&id=53d8cad2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__